export default {
  'profile.signiture': 'مدیریت امضاء ها',
  'profile.signituresave': 'امضا با موفقیت ذخیره گردید',
  'profile.signitureerror': 'لطفا دوباره سعی نمایید',
  'profile.updatesuccess': 'پروفایل شما با موفقیت ویرایش گردید',
  'profile.insertsuccess': 'پروفایل شما با موفقیت ثبت گردید',
  'profile.profile': 'پروفایل',
  'profile.employeemanagement': 'مدیریت کارمندان',
  'profile.airlinequota': 'سهم ایرلاین',
  'profile.updatepassword':
    'لطفا برای ادامه رمز عبور خود را به روز رسانی نمایید',
  'profile.firstname': 'نام',
  'profile.newpassword': 'رمز عبور جدید',
  'profile.oldpassword': 'رمز عبور قبلی',
  'profile.selectavatar': 'انتخاب عکس نمایه',
  'profile.lastname': 'نام خانوادگی',
  'profile.mobile': 'موبایل',
  'profile.username': 'نام کاربری',
  'profile.phone': 'تلفن ',
  'profile.setworkinghours': 'تنظیم ساعات کاری',
  'profile.nationalcode': 'کد ملی',
  'profile.weekdays': 'روز های هفته',
  'profile.deleteconfirmation': 'آیا از حذف رکورد مطمئن هستید؟',
  'profile.rolename': 'نام نقش',
  'profile.register': 'ثبت نام',
  'profile.delete': 'حذف',
  'profile.search': 'جستجو',
  'profile.addemployee': 'اضافه کردن کارمند جدید',
  'profile.cancel': 'انصراف',
  'profile.number': 'ردیف',
  'profile.fromtime': 'از ساعت',
  'profile.totime': 'تا ساعت',
  'profile.close': 'بستن',
  'profile.savechanges': 'ذخیره تغییرات',
  'profile.password': 'رمز عبور',
  'profile.email': 'ایمیل',
  'profile.selectyear': 'انتخاب سال تولد',
  'profile.selectmonth': 'انتخاب ماه تولد',
  'profile.selectday': 'انتخاب روز تولد',
  'profile.username/email': 'نام کاربری / ایمیل',
  'profile.gender': 'جنسیت',
  'profile.logo': 'نمایه',
  'profile.workinghours': 'ساعات کاری',
  'profile.nationalcardfile': 'فایل کارت ملی',
  'profile.addfile': 'اضافه کردن فایل',
  'profile.address': 'آدرس',
  'profile.addresswithoutindex': 'آدرس',
  'profile.phonewithoutindex': 'تلفن',
  'profile.editinformation': 'ویرایش اطلاعات پروفایل',
  'profile.companyname': 'نام شرکت',
  'profile.englishcompanyname': 'نام انگلیسی شرکت',
  'profile.persiancompanyname': 'نام محلی شرکت',
  'profile.removeaddress': 'حذف آدرس',
  'profile.moreaddress': 'آدرس بیشتر',
  'profile.removephone': 'حذف موبایل',
  'profile.addphone': 'موبایل بیشتر',
  'profile.licensefile': 'فایل گواهی',
  'profile.birthdate': 'تاریخ تولد',
  'profile.book/reserve': 'سفارشات  من',
  'profile.onlinesupport': 'پشتیبانی آنلاین',
  'profile.employees': 'کارمندان',
  'profile.editprofile': 'ویرایش پروفایل حقوقی',
  'profile.encompanyname': 'نام انگلیسی شرکت ( اجباری )',
  'profile.facompanyname': 'نام فارسی شرکت ( اجباری )',
  'profile.registercode': 'شماره ثبت',
  'profile.managername': 'نام مدیر / نماینده ( اجباری )',
  'profile.businessmanagername': 'نام مدیر',
  'profile.type': 'نوع پروفایل ( اجباری )',
  'profile.businesstype': 'نوع پروفایل',
  'profile.change': 'ویرایش',
  'profile.adminitstrator': 'مدیر',
  'profile.changepassword': 'تغییر رمز عبور',
  'profile.editpersonalprofile': 'ویرایش پروفایل شخصی',
  'profile.addprofile': 'ثبت پروفایل حقوقی جدید',
  'profile.addbusiness': 'ثبت پروفایل حقوقی',
  'profile.myprofile': 'پروفایل من',

  'profile.signout': 'خروج',
  'profile.quotaadd': 'اطلاعات شما با موفقیت ثبت گردید',
  'profile.addsigniture': 'ثبت امضاء',
  'profile.profiletype': 'انتخاب نوع پروفایل',
  'profile.profilsend':
    'پروفایل جهت بررسی ارسال گردید. مراتب به زودی به شما اعلام میگردد',
  'profile.suspend': 'معلق',
  'profile.activitycode': 'کد فعالیت صنفی(اجباری)',
  'profile.nationalid': 'شناسه ملی(اجباری)',
  'profile.deleteemployee': 'حذف کارمند',
  'profile.economiccode': 'کد اقتصادی(اجباری)',
  'profile.businessactivitycode': 'کد فعالیت صنفی',
  'profile.businessnationalid': 'شناسه ملی',
  'profile.businesseconomiccode': 'کد اقتصادی',
  'profile.choosegateway': 'انتخاب گیت وی',
  'profile.testconnection': 'تست کانکشن',
  'profile.savesigniture': 'ثبت امضاء',
  'profile.signitureping': 'گیت وی با موفقیت پینگ گردید',
  'profile.country': 'کشور',
  'profile.city': 'شهر',
  'profile.role': 'سمت',
  'profile.whoareyou': 'شما چه کسی هستید؟',
  'profile.license': 'ثبت مجوزها',
  'profile.removelicense': 'حذف مجوز',
  'profile.addlicense': 'ثبت مجوز',
  'profile.viewlicense': 'نمایش مجوزها',
  'profile.licenses': 'مجوز ها',
  'profile.licensetype': 'نوع',
  'profile.transferType': 'نوع انتقال',
  'profile.upload': 'آپلود',
  'profile.licenseno': 'شماره مجوز',
  'profile.underprocess': 'درحال بررسی',
  'profile.fullname': 'نام کامل',
  'profile.airlinemarkup': 'سهم فروش بلیط هواپیما',
  'profile.airlinename': 'نام ایرلاین',
  'profile.airlinetype': 'نوع ایرلاین',
  'profile.quota': 'سهم فروش',
  'profile.markup': 'نرخ فروش',
  'profile.savequota': 'ذخیره سهم فروش',
  'profile.currency': 'واحد پولی',
  'profile.passportNumber': 'شماره گذرنامه',
  'profile.userPointType': 'کاربر',
  'profile.point': 'امتیاز',
  'profile.savepoint': 'ثبت امتیاز',
  'profile.userpoint': 'امتیاز کاربر',
  'profile.subject': 'موضوع',
  'profile.date': 'تاریخ ثبت',
  'profile.totaluserpoint': 'مجموع امتیازات',
  'profile.individualprofile': 'ویرایش پروفایل حقیقی',
  'profile.viewdetails': 'مشاهده جزئیات',
  'profile.provider': 'مهیا کننده',
  'profile.b2brequest': 'درخواست سرویس',
  'profile.language': 'تغییر زبان',
  'profile.department': 'دپارتمان',
  'profile.adddetail': 'ثبت جزئیات بیشتر (اختیاری)',
  'profile.identityno': 'شماره شناسنامه',
  'profile.inviteemployee': 'دعوت کارمند',
  'profile.gateway': 'گیت وی',
  'profile.hi': 'سلام',
  'profile.status': 'وضعیت',
  'profile.copy': 'کپی شد',
  'profile.approve': 'تایید',
  'profile.dissapprove': 'عدم تایید',
  'profile.agree': 'تایید',
  'profile.bankaccounttype': 'انواع حساب های بانکی',
  'profile.pending': 'درحال بررسی',
  'profile.notexitstuser': 'نام کاربری وجود ندارد',
  'profile.completeprofilepoint': 'جهت کسب امتیاز پروفایل خود را تکمیل نمایید',
  'profile.selectrole': 'سمت و واحد را انتخاب نمایید',
  'profile.invitesuccessfully': 'دعوت نامه با موفقیت ارسال گردید',
  'profile.description': 'توضیحات',
  'profile.filldescription': 'لطفا توضیحات را وارد نمایید',
  'profile.dashboard': 'داشبورد',
  'profile.mydashboard': 'داشبورد من',
  'profile.saleaccounting': 'گزارشات فروش',
  'profile.profileaccounts': 'مدیریت حساب بانکی',
  'profile.financialmanagement': 'مدیریت مالی',
  'profile.commissionmanagement': 'مدیریت امتیاز',
  'profile.uploadlogo': 'آپلود لوگوی شرکت',
  'profile.uploadlicense': 'آپلود مجوز',
  'profile.deleteprofile': 'حذف پروفایل',
  'profile.airlineCommission': 'مدیریت سهم و مارک آپ',
  'profile.licensepic': 'تصویر مجوز',
  'profile.errordelete': 'امکان حذف رکورد وجود ندارد',
  'profile.editverification':
    'با توجه به تغییر وضعیت به حالت معلق آیا از ویرایش پروفایل مطمئن هستید',
  'profile.reference': 'مرجع صادر کننده',
  'profile.logotitle': 'جهت ویرایش لوگوی شرکت بر روی گزینه زیر کلیک نمایید',
  'profile.invitedepartment': 'کاربر گرامی شما به واحد ',
  'profile.inviteprofile': ' در پروفایل حقوقی ',
  'profile.inviterole': ' با سمت ',
  'profile.invite': ' دعوت شده اید. در صورت تمایل لطفا دعوت را تایید نمایید.',
  'profile.countercommission': 'سهم کانتر',
  'profile.ownercommission': 'سهم مالک',
  'profile.commission': 'کمیسیون',
  'profile.addQuota': 'سهمیه اضافه کنید',
  'profile.newQuota': 'سهمیه جدید',
  'profile.customermanagement': 'مدیریت مشتریان',
  'profile.active': 'فعال',
  'profile.disactive': 'غیر فعال',
  'profile.Individual': 'حقیقی',
  'profile.bussiness': 'حقوقی',
  'profile.postalcode': 'کد پستی',
  'profile.fax': 'فکس',
  'profile.webSite': 'وب سایت',
  'profile.accountingcode': 'کد حسابداری',
  'profile.deletecustomer': 'حذف مشتری',
  'profile.insertcustomer': 'ثبت اطلاعات مشتری',
  'profile.updatecustomer': ' ویرایش اطلاعات مشتری',
  'profile.reload': 'بازنشانی اطلاعات',
  'profile.reloadfilter': 'بازنشانی فیلتر',
  'profile.both': 'هر دو',
  'profile.isbusiness': 'حقوقی',
  'profile.isactive': 'فعال',
  'profile.name': 'نام',
  'profile.registerdate': 'تاریخ ثبت',
  'profile.chargewallet': 'شارژ کیف پول',
  'profile.currentcredit': 'موجودی کنونی کیف پول',
  'profile.walletbalance': 'موجودی کیف پول',
  'profile.amount': 'مبلغ افزایش شارژ',
  'profile.chargeamount': 'مبلغ شارژ (ریال)',
  'profile.chargecreditmessgae':
    'برای خرید آسان و سریع، کیف پول خود را شارژ نمایید .',
  'profile.credit': 'اعتبار شما :',
  'profile.errordelete': 'امکان حذف رکورد وجود ندارد',
  'profile.editverification':
    'با توجه به تغییر وضعیت به حالت معلق آیا از ویرایش پروفایل مطمئن هستید',
  'profile.reference': 'مرجع صادر کننده',
  'profile.logotitle': 'جهت ویرایش لوگوی شرکت بر روی گزینه زیر کلیک نمایید',
  'profile.paymentdate': 'تاریخ پرداخت',
  'profile.businessbooking': 'سفارشات من',
  'profile.gotowalletpage': 'بازگشت به صفحه شارژ کیف پول',
  'profile.notfound': 'موردی یافت نگردید',
  'profile.message': 'پیام',
  'profile.mypoint': 'امتیاز من',
  'profile.pointtransaction': 'تراکنش امتیاز',
  'profile.transaction': 'تراکنش',
  'profile.buypoints': 'خرید امتیاز',
  'profile.wallet': 'کیف پول ',
  'profile.chooseRole': 'نقشی را انتخاب کنید',
  'profile.mycredit': 'اعتبار من',
  'profile.tourManagement': 'مدیریت تور',
  'profile.departmentmanagement': 'مدیریت دپارتمان',
  'profile.customerphrase': 'نام / کد حسابداری',
  'profile.enterusername': 'نام کاربری مورد نظر را وارد نمایید',
  'profile.menucredit': 'اعتبار :',
  'profile.personalprofile': 'پروفایل شخصی',
  'profile.employeesearch': 'جستجو بر اساس نام ، نام خانوادگی و شماره موبایل',
  'profile.gotowalletpage': 'برگشت به صفحه شارژ کیف پول',
  'profile.documentdescription': 'شرح سند',
  'profile.messagedescription': 'شرح پیام',
  'profile.documentnumber': 'شماره سند',
  'profile.registertime': 'زمان ثبت',
  'profile.price': 'مبلغ(ریال)',
  'profile.errorsecondpassword': 'رمز دوم و تکرار رمز دوم یکسان نمی باشد',
  'profile.nowheretoursmanagement': 'مدیریت تور های ناکجا',
  'profile.successsecondpassword': 'رمز دوم با موفقیت ثبت گردید',
  'profile.insertinformation': 'ثبت اطلاعات',
  'profile.businessprofile': 'پروفایل حقوقی',
  'profile.creditmanagement': 'مدیریت اعتبار',
  'profile.affiliateMarketing': 'بازاریابی وابسته',
  'profile.account': 'حساب کاربری',
  'profile.individual': 'شخصی',
  'profile.business': 'حقوقی',
  'profile.myfriends': 'دوستان من',
  'profile.viewCreditsAndWallets': 'مشاهده اعتبار و کیف پول',
  'profile.employeeManagement': 'مدیریت کارکنان ',
  'profile.customerManagement': 'مدیریت مشتری',
  'profile.employeeList': 'لیست کارمندان',
  'profile.addEmployee': 'افزودن کارمند ',
  'profile.sendingInvitation': 'ارسال دعوت نامه',
  'profile.employee': 'کارمند',
  'profile.call': 'تماس',
  'profile.message': 'پیام',
  'profile.increaseOrEditCredentials': 'افزایش یا ویرایش اعتبار',
  'profile.messagedate': 'تاریخ پیام',
  'profile.startMessagedate': 'تاریخ پیام از',
  'profile.endMessagedate': 'تاریخ پیام تا',
  'profile.pointsremain': 'امتیاز',
  'profile.profileedit': 'ویرایش پروفایل',
  'profile.addCustomer': 'افزودن مشتری',
  'profile.addcity': 'افزودن شهر',
  'profile.upgradeYourPlan': 'طرح خود را ارتقا دهید ',
  'profile.planCustomer': 'طرح مشتری',
  'profile.walletremain': 'مانده کیف پول',
  'profile.bankreceipt': 'فیش بانکی',
  'profile.online': 'درگاه پرداخت',
  'profile.increasebalance': 'افزایش موجودی',
  'profile.selectedbills': 'صورت حساب های انتخابی',
  'profile.paymentbills': 'پرداخت فاکتورها',
  'profile.sendToGroup': 'ارسال به گروه',
  'profile.theDesiredRole': 'سمت مورد نظر',
  'profile.addDepartment': 'افزودن دپارتمان',
  'profile.employeeRole': 'نقش کارمند',
  'profile.moreDetails': 'جزییات بیشتر',
  'profile.mehdiAbdollahiMehr': 'مهدی عبدالهی مهر',
  'profile.hiMessage': 'سلام کجا هستی ؟',
  'profile.inWork': 'در کار',
  'profile.addNew': 'جدید اضافه کن',
  'profile.reminding': 'یادآوری',
  'profile.participate': 'مشارکت ',
  'profile.sportsInteractive': 'ورزشی تعاملی',
  'profile.team': 'تیم',
  'profile.tasks': 'وظایف',
  'profile.chooseAnArtist': 'یک هنرمند را انتخاب کنید',
  'profile.prepareForACallWithAClient': 'برای تماس با مشتری آماده شوید',
  'profile.prepareAEKTemplateForTheClient': 'یک قالب EK برای مشتری آماده کنید',
  'profile.prepareDetiledBrief':
    'خلاصه مفصلی را برای طراحان و طراحان 04:12 آماده کنید',
  'profile.more': 'بیشتر',
  'profile.position': 'موقعیت',
  'profile.employeeInformation': 'اطلاعات کارمند',
  'profile.employeeRegistrationDate': 'تاریخ ثبت کارمند',
  'profile.creditAmount': 'مبلغ اعتبار',
  'profile.transferamount': 'مبلغ انتقال',
  'profile.theCeilingOfEachPurchase': 'سقف هر خرید',
  'profile.validityDuration': 'مدت زمان اعتبار',
  'profile.creditStatus': 'وضعیت اعتبار',
  'profile.increaseCredit': 'افزایش اعتبار',
  'profile.editCredit': 'ویرایش اعتبار',
  'profile.employeeCredit': 'اعتبار کارمند',
  'profile.creditBalance': 'مانده اعتبار',
  'profile.aboutme': 'دانستنی های من',
  'profile.myfavouritecity': 'شهر های مورد علاقه من',
  'profile.loan': 'قرض الحسنه',
  'profile.gift': 'هدیه',
  'profile.messageType': 'نوع پیام ',
  'profile.text': 'متنی',
  'profile.file': 'فایل',
  'profile.customerList': 'لیست مشتریان',
  'profile.totalPurchaseAmount': 'میزان کل خرید',
  'profile.topCustomers': 'مشتریان برتر',
  'profile.homeAppliancesSeller': 'فروشنده لوازم خانگی',
  'profile.pointsInventory': 'موجودی امتیاز',
  'profile.pointCard': 'کارت امتیاز',
  'profile.shoppingList': 'لیست خرید',
  'profile.purchases': 'خرید ها',
  'profile.customerInformation': 'اطلاعات مشتری',
  'profile.customerRegistrationDate': 'تاریخ ثبت مشتری',
  'profile.customerShoppingList': 'لیست خرید مشتری',
  'profile.incomeFromTheCustomer': 'درآمد از مشتری',
  'profile.companyAddress': 'آدرس شرکت',
  'profile.nameOfCEO': 'نام مدیرعامل',
  'profile.registration/priceChange': 'ثبت / تغییر قیمت',
  'profile.printPassengerInvoice': 'چاپ فاکتور مسافر',
  'profile.registrationPaymentReceipts': 'ثبت فیش پرداختی',
  'profile.priceToBuyFromOwner': 'قیمت خرید از تریپسی',
  'profile.salesPriceCustomer': 'فیمت فروش به مشتری',
  'profile.salesManager': 'مسئول فروش',
  'profile.showLess': 'نمایش کمتر',
  'profile.purchaseRate': 'نرخ خرید',
  'profile.changeTicketSalesRates': 'تغییر نرخ فروش بلیط',
  'profile.savePrice': 'ذخیره قیمت',
  'profile.remainingAmount': 'مبلغ باقیمانده',
  'profile.firstPayment': 'پرداخت اول',
  'profile.settlementOfTickets': 'تسویه بلیط',
  'profile.totalAmount': 'مبلغ کل',
  'profile.attachedPaymentReceipt': 'ضمیمه فیش پرداختی',
  'profile.attachedPaymentReceipt1': 'ضمیمه فیش پرداختی اول',
  'profile.attachedPaymentReceipt2': 'ضمیمه فیش پرداختی دوم',
  'profile.attachedPaymentReceipt3': 'ضمیمه فیش پرداختی سوم',
  'profile.attachedPaymentReceipt4': 'ضمیمه فیش پرداختی چهارم',
  'profile.attachedPaymentReceipt5': 'ضمیمه فیش پرداختی پنجم',
  'profile.totalRemaining': 'کل مانده',
  'profile.saveAndNextReceipt': 'ذخیره و فیش بعدی',
  'profile.saveAndExit': 'ذخیره و خروج',
  'profile.editEmployeeInformation': 'ویرایش اطلاعات کارمند',
  'profile.travel': 'سفر',
  'profile.editconfirmation':
    'با ارسال درخواست ویرایش، پروفایل شما تا زمان تایید از سمت تریپسی معلق میگردد. آیا با انجام ویرایش موافق هستید؟ ',
  'profile.searchtobuy': 'نسبت جستجو به خرید',
  'profile.listOfPassengers': 'لیست مسافران',
  'profile.me': 'درباره خود توضیح دهید. امتیاز بگیرید.',
  'profile.customer': 'مشتری',
  'profile.showinfo': 'نمایش اطلاعات',
  'profile.editPassengerInformation': 'ویرایش اطلاعات مسافر',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'مسافر شما با موفقیت ثبت گردید',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'اطلاعات مسافر مورد نظر با موفقیت ویرایش شد',
  'profile.customerSuccessfullyRegistered': 'مشتری با موفقیت ثبت شد',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'اطلاعات مشتری  با موفقیت ویرایش شد',
  'profile.addfriend': 'افزودن دوست',
  'profile.inveitefriend': 'دعوت دوستان',
  'profile.inviteEmployees': 'دعوت کارمندان',
  'profile.addEmployees': 'افزودن کارمندان',
  'profile.textEmployees':
    'از طریق فرم زیر میتوانید به کارمندانی که از شرکت خود خارج شده اند و نام کاربری فعال دارند دعوت نامه ارسال کنید',
  'profile.textCustomer':
    'از طریق فرم زیر میتوانید مشتریان مورد نظر خود را با تکمیل اطلاعات زیر به مجموعه بیافزایید',
  'profile.textAddemplo':
    'از طریق فرم زیر می توانید کارمندان جدید را به شرکت اضافه نمایید و از طریق امکانات مختلف سامانه بر عملکرد آنها نظارت نمایید',
  'profile.textDepartment':
    'از طریق فرم زیر میتوانید دپارتمان مورد نظر را ثبت و یا باز نشانی کنید',
  'profile.textPassword':
    'از طریق فرم زیر میتوانید رمز عبور خود را تغییر دهید و رمز عبور جدید خود را تعریف نمایید .',
  'profile.textSecondPassword':
    'از طریق فرم زیر میتوانید رمز دوم ایستا خود را تغییر دهید و رمز دوم ایستا جدید خود را تعریف نمایید .',
  'profile.textLicense':
    'در این صفحه می توانید مجوز های آژانس مورد نظر خود را مشاهده فرمایید .',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'مسافر شما با موفقیت ثبت گردید',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'اطلاعات مسافر مورد نظر با موفقیت ویرایش شد',
  'profile.customerSuccessfullyRegistered': 'مشتری با موفقیت ثبت شد',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'اطلاعات مشتری  با موفقیت ویرایش شد',
  'profile.editEmployeeSuccessfully': 'ویرایش کارمند با موفقیت انجام شد .',
  'profile.updateEmployeeSuccess':
    'اطلاعات کارمند مورد نظر با موفقیت ویرایش گردید',
  'profile.mostSales': 'بیشترین تعداد فروش',
  'profile.theLowestNumberOfSales': 'کمترین تعداد فروش',
  'profile.mostSalesAmount': 'بیشترین مبلغ فروش',
  'profile.theLowestSalesAmount': 'کمترین مبلغ فروش',
  'profile.mostActivityTime': 'بیشترین زمان فعالیت',
  'profile.minimumActivityTime': 'کمترین زمان فعالیت',
  'profile.employeeActivities': 'فعالیت های کارمند',
  'profile.customerUpdate': 'ویرایش مشتری',
  'profile.applyChanges': 'اعمال تغییرات',
  'profile.planPassenger': 'طرح مسافر',
  'profile.all': 'همه',
  'profile.Activities': 'فعالیت ها',
  // "profile.allEmployeeRoles": "All employee roles ",
  'profile.allProfiles': 'پروفایل ها',
  'profile.allStatuses': 'وضعیت ها',
  'profile.dragtoadd': 'برای افزودن بکشید',
  'profile.dragtotransfer': 'برای انتقال بکشید',
  'profile.alltransactions': 'همه تراکنش ها',
  'profile.changedate': 'تغییر تاریخ',
  'profile.employeeSelection': 'انتخاب کارمند',
  'profile.sendMessage': 'ارسال پیام',
  'profile.groupSending': 'ارسال گروهی',
  'profile.showDetails': 'نمایش جزییات',
  'profile.editingInformation': 'ویرایش اطلاعات',
  'profile.changeLogo': 'تغییر لوگو',
  'profile.allocation': 'تخصیص اعتبار',
  'profile.allusers': 'همه کاربران',
  'profile.onlineFriend': 'دوستان فعال من',
  'profile.onlinePeople': ' نفر آنلاین ',
  'profile.recentTravels': ' آخرین سفرها ',
  'profile.mounthReport': 'گزارش عملکرد یکماه اخیر ',
  'profile.recentNews': ' آخرین اخبار ',
  'profile.tourismNews': ' اخبار مربوط به گردشگری ',
  'profile.recentMonthActivitie': ' فعالیت های یکماه اخیر ',
  'profile.NumberFlightPurchases': ' تعداد خرید پرواز ',
  'profile.NumberFlightSearches': ' تعداد جستجوی پرواز ',
  'profile.services': 'سرویس های ما',
  'profile.donutChart': 'سفر های انجام شده',
  'profile.startTravelDate': 'تاریخ سفر از',
  'profile.endTravelDate': 'تاریخ سفر تا',
  'profile.presensnt': 'حاضر',
  'profile.absence': 'غیبت',
  'profile.leave': 'مرخصی',
  'profile.activeTour': 'تور های فعال',
  'profile.finishedTour': 'تور های پایان یافته',
  'profile.createTour': 'ایجاد تور',
  'profile.choose': 'انتخاب',
  'profile.increaseCredit': 'افزایش اعتبار',
  'profile.textIncrease':
    'از طریق فرم زیر می توانید اعتبار خود را افزایش دهید .',
  'profile.textEditingTripsi':
    'از طریق فرم زیر می توانید اطلاعات پروفایل خود را تغییر دهید و توجه داشته باشید که پس از تغییرات پروفایل معلق می گردد تا توسط تریپسی تایید گردد .',
  'profile.textEditingTripord':
    'از طریق فرم زیر می توانید اطلاعات پروفایل خود را تغییر دهید و توجه داشته باشید که پس از تغییرات پروفایل معلق می گردد تا توسط تریپ اُرد تایید گردد .',
  'profile.reservations': 'رزرو ها',
  'profile.row': 'ردیف',
  'profile.transactions': 'تراکنش ها',
  'profile.searchHistory': 'تاریخچه جستجو',
  'profile.Transactions': 'تراکنش ها',
  'profile.Invoices': 'فاکتور ها',
  'profile.assetManagment': 'مدیریت دارایی',
  'profile.transaction': 'تراکنش',
  'profile.transactionnumber': 'شماره تراکنش : ',
  'profile.Invoice': 'فاکتور',
  'profile.Credit': 'اعتبار',
  'profile.myProfile': 'پروفایل من',
  'profile.textProfile':
    'در این بخش می توانید اطلاعات پروفایل خود را مشاهده کنید .',
  'profile.textAddfriend':
    'از طریق فرم زیر می توانید به دوستان خود دعوت نامه بفرستید و آنها را به مجموعه دوستان خود اضافه نمایید .',
  'profile.textFriend':
    'از طریق فرم زیر می توانید اطلاعات دوستان خود را وارد نمایید و در آخر ثبت اطلاعات کنید . ',
  'profile.uploadText':
    'در این صفحه می توانید با کلیک بروی لینک زیر , نمایه مورد نظر را بارگزاری کنید .',
  'profile.reserves': 'رزرو ها',
  'profile.Invite': 'دعوت',
  'profile.add': 'افزودن',
  'profile.passengers': 'مسافران',
  'profile.messages': 'پیام ها',
  'profile.Services': 'خدمات',
  'profile.Info': 'مشخصات',
  'profile.transportation': 'حمل و نقل',
  'profile.inhabitancy': 'اقامت',
  'profile.facilities': 'امکانات',
  'profile.pricing': 'قیمت گذاری',
  'profile.clubCard': 'کارت باشگاه',
  'profile.messageNo': 'شماره پیام',
  'profile.viewInvoice': 'مشاهده فاکتور',
  'profile.loading': 'در حال بارگزاری...',
  'profile.moreAddressees': 'نمایش بیشتر آدرس ها',
  'profile.morePhoneNumbers': 'نمایش بیشتر تلفن ها',
  'profile.flight': 'پرواز',
  'profile.paid': 'پرداخت شده',
  'profile.unpaid': 'پرداخت نشده',
  'profile.choosefile': 'انتخاب فایل',
  'profile.sellername': 'نام فروشنده',
  'profile.factoreno': 'شماره فاکتور',
  'profile.customername': 'نام خریدار',
  'profile.phonenumber': 'شماره همراه',
  'profile.printinvoice': 'چاپ فاکتور',
  'profile.signature': 'مهر و امضای حسابداری',
  'profile.signaturetext': 'بدون مهر و امضای حسابداری فاقد اعتبار است.',
  'profile.servicedescription': 'شرح خدمات',
  'profile.taxesduties': 'مالیات و عوارض',
  'profile.purchaseamount': 'مبلغ خرید',
  'profile.friendsearch': 'نام , کد ملی , شماره گذرنامه',
  'profile.ticketsearch': 'عنوان , شماره تیکت',
  'profile.messagesearch': 'موضوع , شماره پیام',
  'profile.bookingflightsearch': 'نام , شماره سفارش',
  'profile.transactionsearch': 'نام , شماره سفارش',
  'profile.employeesearch': 'نام , ایمیل',
  'profile.customersearch': 'نام مشتری',
  'profile.passangersearch': 'نام , کد ملی  , شماره گذرنامه',
  'profile.activities': 'عملیات',
  'profile.addlicenselink': 'افزودن مجوز',
  'profile.startnewsevent': 'آغاز رویداد',
  'profile.endnewsevent': 'پایان رویداد',
  'profile.descriptionnews': 'متن خبر : ',
  'profile.introduction': 'مقدمه',
  'profile.firsttravel': 'در انتظار اولین سفرمون...',
  'profile.notfoundnews': 'اخباری یافت نگردید',
  'profile.notfoundtravel':
    'تاکنون سفری نداشتین. منتظر اولین سفر شما هستیم... ',
  'profile.notfoundtravel': `تاکنون سفری نداشتین.`,
  'profile.waitingTrip': 'منتظر اولین سفر شما هستیم...',
  'profile.addLicenseText':
    'از طریق فرم زیر می توانید مجوزهای خود را وارد نمایید و در آخر ثبت اطلاعات کنید . ',
  'profile.simpleuser': 'کاربر عادی',
  'profile.owner': 'مالک',
  'profile.crm': 'ارتباط با مشتری',
  'profile.counter': 'کانتر',
  'profile.accountants': 'حسابدار',
  'profile.roles': 'نقش ها',
  'profile.submitchangerate': 'تغییر نرخ فروش با موفقیت ثبت گردید.',
  'profile.paymentdescription':
    'در این قسمت می توانید با بارگزاری فیش پرداختی خود ، خرید خود را در چندین قسط پرداخت نمایید. ',
  'profile.paymentprice': 'مبلغ پرداختی',
  'profile.savesuccessfully': 'با موفقیت ذخیره شد.',
  'profile.viewfile': 'مشاهده فایل',
  'profile.backgammon': 'تخته نرد',
  'profile.chatgpt': 'چت جی پی تی',
  'profile.calendar': 'تقویم',
  'profile.game': 'سرگرمی',
  'profile.addgateway': 'افزودن مسیر پروازی',
  'profile.editgateway': 'ویرایش مسیر پروازی',
  'profile.addgatewaydescription':
    'در این فرم، میتوانید مسیر پروازی مد نظر خود را ثبت کنید. پس از ثبت، جستجو ها طبق مسیر پروازی های ثبت شده انجام می شوند',
  'profile.editgatewaydescription':
    'در این فرم، میتوانید مسیر پروازی مد نظر خود را ویرایش کنید. پس از ویرایش، جستجو ها طبق مسیر پروازی های ثبت شده انجام می شوند',
  'profile.gatewayroutes': 'مسیرهای پروازی',
  'profile.airlinecode': 'کد ایرلاین',
  'profile.internalcode': 'کد داخلی',
  'profile.weekdays': 'روز های هفته',
  'profile.known': 'مشخص',
  'profile.unknown': 'نامشخص',
  'profile.airlinestatus': 'وضعیت ایرلاین',
  'profile.allroutes': 'تمامی مسیر ها',
  'profile.selectoriginanddestination': 'مبدا و مقصد',
  'profile.siti': 'سیتی',
  'profile.sito': 'سیتو',
  'profile.soti': 'سوتی',
  'profile.soto': 'سوتو',
  'profile.pathchoice': 'انتخاب مسیر',
  'profile.submiteditgateway': 'ثبت ویرایش مسیر',
  'profile.submitaddgateway': 'ثبت مسیر پروازی',
  'profile.selectflightsdays': 'انتخاب روزهای پرواز',
  'profile.departureflightcity': 'شهر مبدا پرواز',
  'profile.arrivalflightcity': 'شهر مقصد پرواز',
  'profile.ascinternalcode': 'روند صعودی کد داخلی',
  'profile.descinternalcode': 'روند نزولی کد داخلی',
  'profile.ascairlinecode': 'روند صعودی کد ایرلاین',
  'profile.descairlinecode': 'روند نزولی کد ایرلاین',
  'profile.addgatewaysuccessfully': 'مسیر پروازی با موفقیت ثبت گردید',
  'profile.editgatewaysuccessfully': 'مسیر پروازی مد نظر با موفقیت ویرایش شد',
  'profile.notallowed': 'امکان انتخاب پروفایل قبل از تایید آن وجود ندارد',
  'profile.addcustomerduplicated': 'مشتری مورد نظر قبلا ثبت نام شده است',
  'profile.discount': 'تخفیف',
  'profile.sendfile': 'ارسال فیش بانکی',
  'profile.sendfiles': 'ارسال فیش های بانکی',
  'profile.factorestartdate': 'تاریخ فاکتور از',
  'profile.factoreenddate': 'تاریخ فاکتور تا',
  'profile.factoredate': 'تاریخ فاکتور',
  'profile.allfactors': 'تمامی فاکتور ها',
  'profile.walletnotenough': 'موجودی کیف پول کافی نمی باشد',
  'profile.approvePrice': 'مبلغ تایید شده',
  'profile.changesecondpassword': 'تغییر رمز دوم',
  'profile.oldsecondpassword': 'رمز دوم قبلی',
  'profile.newsecondpassword': 'رمز دوم جدید',
  'profile.submitsecondpassword': 'تغییر رمز دوم',
  'profile.secondpasssuccessfully': 'تغییر رمز دوم با موفقیت انجام شد',
  'profile.oldsecondpassword': 'رمز دوم قبلی',
  'profile.setSecondPasswordInfo':
    'اکر برای اولین رمز دوم را ست میکنین. نیازی به وارد کرد این فیلد نیست.',
};
